import styled from 'styled-components';
import { NoResult } from 'ui/illustrations';
import { useAdAccountContext } from '../../contexts/AdAccountContext';
import { useFacebookLoginContext } from '../../contexts/FacebookLoginContext';
import { useFbcaTranslations } from '../../hooks/useTranslations';

const NoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: ${({ theme }) => theme.spacing.utils.pxToRem(350)};
  justify-content: center;
`;

const NoResultsHeader = styled.div`
  ${({ theme }) => theme.styles.body.body1Strong};
  font-size: ${({ theme }) => theme.styles.fontSizes.s20};
  font-weight: ${({ theme }) => theme.styles.fontWeights.bold};
`;

const NoResultContent = styled.div`
  ${({ theme }) => theme.styles.body};
  ${({ theme }) => theme.styles.fontSizes.s14}
`;

export const NoAdAccountResults = () => {
  const { loginCode } = useFacebookLoginContext();
  const { allAdAccountIds } = useAdAccountContext();
  const { t } = useFbcaTranslations();

  const constructErrorMessage = () => {
    if (!loginCode) {
      return t('error.login');
    } else if (allAdAccountIds.length === 0) {
      return t('error.adAccountIds');
    } else {
      return t('error.default');
    }
  };

  const errorMessage = constructErrorMessage();

  return (
    <NoResultsContainer>
      <NoResult />
      <NoResultsHeader>{t('error.header')}</NoResultsHeader>
      <NoResultContent>{errorMessage}</NoResultContent>
    </NoResultsContainer>
  );
};
